import { api } from 'api'
import { MonthlyChargeLimit, MonthTotalCharge } from 'typings/common_defs'

type GetChargeLimitsResponse = {
  monthlyChargeLimit: MonthlyChargeLimit
  monthTotalCharge: MonthTotalCharge
}

export async function getChargeLimits() {
  const response = await api.post<GetChargeLimitsResponse>(
    '/company/graphql_dispatch/current_company_01b74516',
    {}
  )

  return {
    monthlyChargeLimit: response.data.monthlyChargeLimit,
    monthTotalCharge: response.data.monthTotalCharge,
  }
}

export function updateSpendLimit(companyId: number, spendLimit: number) {
  return api.put(`/company/${companyId}/money/add_spend_limit`, {
    spend_limit: spendLimit,
  })
}

export function updateBonusLimit(companyId: number, bonusLimit: number) {
  return api.put(`/company/${companyId}/money/add_bonus_limit`, {
    bonus_limit: bonusLimit,
  })
}
